<script>
  import SectionHeading from "../shared/SectionHeading.svelte";
  import WorkCard from "../shared/WorkCard.svelte";
  import Grid from "../shared/Grid.svelte";
  import work from "../stores/work";
  import app from "../stores/app";
</script>

<div class="relative overflow-x-hidden">
  <div class="max-w-7xl mx-auto px-4 py-8 z-50" id="my-work">
    {#if $app.lang === "en"}
      <SectionHeading text1="MY" text2="WORK" />
    {:else}
      <SectionHeading text1="MES" text2="PROJECTS" />
      <span />
    {/if}
    <h1 class="pb-16 text-base md:text-center">
      {#if $app.lang === "en"}
        <span class="text-lg align-middle">
          Have a look at some of my works. Click on see project <span
            class="material-symbols-outlined align-middle text-brand-green"
          >
            visibility
          </span>
          to view a live demo.
          <br class="sm:hidden" />
          <br />
          For security and privacy reasons, No demo can be provided for enterprises'
          private projects such as internal tools.
          <br class="--sm:hidden" />
          <br />
          All projects still in the development phase will not be shown as well.
        </span>
      {:else}
        <span class="text-lg align-middle">
          Jettez un oeil a quelques un de mes projects. Cliquez sur voir le
          project
          <span class="material-symbols-outlined align-middle text-brand-green">
            visibility
          </span>
          pour lancer la démo.
          <br class=" sm:hidden" />
          <br />
          Pour raisons de securité et confidentialité, aucune démo ne pourra être
          fournie pour les projets privés d'entreprises tels que les outils internes.
          <br class="--sm:hidden" />
          <br />
          Les projets encore en phase de développement ne seront pas non plus affichés.
        </span>
      {/if}
    </h1>

    <Grid>
      {#each $work as item (item.id)}
        <WorkCard {...item} />
      {/each}
    </Grid>
  </div>

  <!-- Absolute elements -->
  <img
    src="./images/blob-print-red.svg"
    alt="red blog"
    class="absolute right-0 top-0 w-48"
    style="transform:translate(50%, 150%);z-index:1;"
  />

  <img
    src="./images/blob-print-green.svg"
    alt="red blog"
    class="absolute left-0 top-0 w-56"
    style="transform:translate(-50%, 400%);z-index:1;"
  />

  <img
    src="./images/blob-print-yellow.svg"
    alt="red blog"
    class="absolute right-0 top-0 w-64"
    style="transform:translate(50%, 375%);z-index:1;"
  />
</div>
